import React, { useEffect, useState } from "react";
// import DeleteIcon from '@material-ui/icons-material/Delete';
import { Delete, Add, Edit } from "@material-ui/icons";
import axios from "axios";
import Doller from "../../Assets/images/doller.png";
import { useDispatch, useSelector } from "react-redux";
// import axios from "axios";
import { useAccount } from "wagmi";

function KeyValueForm() {
  const [keyValuePairs, setKeyValuePairs] = useState([{ key: "", value: "" }]);

  const { address, connector, isConnected } = useAccount();
  const [getData, setGetData] = useState([]);
  const [counter, setCounter] = useState("1");
  const [inputValue, setInputValue] = useState("");
  const [flag, setFlag] = useState(false);
  const [loader, setLoader] = useState(false);
  const dispatch = useDispatch();
  const [openModal, setOpenModal] = useState(false);
  const categories = useSelector((state) => state.categories);
  const [credits, setCredits] = useState(0);
  console.log("inputValue ", inputValue);
  const getSeletedValue = useSelector((state) =>
    state.categories.filter((data) => data.status == true).map((data) => data)
  );

  let getCategories = categories.map(function (value, label) {
    return value;
  });

  const [uLoader, setULoader] = useState(false);
  const [upLoader, setUpLoader] = useState(false);

  const [obj, setObj] = useState("");
  const [no, setNo] = useState(1);
  const [sentance, setSentance] = useState("");
  const [json, setJson] = useState();
  const [apiRes, setApiRes] = useState();
  const [lines, setLines] = useState([]);

  const [lSave, setLSave] = useState(false);

  const [aiJson, setAiJson] = useState([]);

  const [imagesList, setImagesList] = useState([]);

  const [prompt, setPrompt] = useState(undefined);

  const [activeIndex, setActiveIndex] = useState(undefined);

  const [editPrompt, setEditPrompt] = useState("");

  const [jobj, setJObj] = useState([]);

  const handleAddInput = () => {
    setKeyValuePairs([...keyValuePairs, { key: "", value: "" }]);
  };

  const handleInputChange = (index, fieldName, value) => {
    const updatedPairs = [...keyValuePairs];
    updatedPairs[index][fieldName] = value;
    setKeyValuePairs(updatedPairs);
  };

  const handleRemoveInput = (index) => {
    const updatedPairs = [...keyValuePairs];
    updatedPairs.splice(index, 1);
    setKeyValuePairs(updatedPairs);
  };

  const handleJsonGenerator = async () => {
    setLoader(true);
    const jsonList = {
      example: sentance,
      object: obj,
      pair: keyValuePairs,
    };
    console.log(jsonList);
    setJson(jsonList);

    const data = {
      prompt: {
        object: obj,
        example: sentance,
        pair: keyValuePairs,
      },
      no: no,
    };

    console.log("Line No 44", data);

    if (data) {
      await axios
        .post(`${process.env.REACT_APP_API_URL}/find-complexity`, data)
        .then(function async(response) {
          console.log("generate images response else block ", response);
          console.log("Line No 96", response.data.data);
          setApiRes(response.data);
          const list = response.data.data
            .split("\\n")
            .map((sentence) => sentence.replace(/^\s+|\s+$/gm, ""));
          setLines(list);
          // fetchData();
        })
        .catch(function (error) {
          console.log(error);
          setLoader(false);
        });
    }
  };

  const fetchData = async () => {
    // if (lines.length > 0) {
    try {
      const promises = lines[0].split("\n").map(async (data) => {
        console.log("113", data);
        return await imageApi(data);
      });

      const promisesJson = lines[0].split("\n").map(async (data) => {
        console.log("122", data);
        return await jsonApi(data);
      });

      const dataList = await Promise.all(promises);
      const jsonList = await Promise.all(promisesJson);
      console.log(promises);
      console.log(jsonList);

      setImagesList(dataList);
      console.log("main data", dataList);

      const updatedData = lines[0].split("\n").map((sentence, index) => {
        // const prompt = sentence.split(':')[1].trim(); // Extract the part after ":"
        return {
          id: index + 1, // Assuming ids start from 1
          prompt: `${sentence}`,
          image: dataList[index][0].url,
          json: jsonList[index],
        };
      });

      setAiJson(updatedData);
      console.log(updatedData);
      setLoader(false);

      // setImg(dataList);
    } catch (error) {
      console.error("Error fetching image data:", error);
      setLoader(false);
    }
  };

  useEffect(() => {
    if (lines.length > 0) {
      fetchData();
    }
  }, [lines]);

  const renderInputs = () => {
    return keyValuePairs.map((pair, index) => (
      <div key={index} className="row">
        <div className="col-md-5 col-sm-12 bannerLeft">
          <div className="form-control ">
            <input
              type="text"
              placeholder="Key"
              value={pair.key}
              onChange={(e) => handleInputChange(index, "key", e.target.value)}
            />
          </div>
        </div>
        <div className="col-md-5 col-sm-12 bannerLeft">
          <div className="form-control ">
            <input
              type="text"
              placeholder="Value"
              value={pair.value}
              onChange={(e) =>
                handleInputChange(index, "value", e.target.value)
              }
            />
          </div>
        </div>

        {keyValuePairs.length !== 1 && (
          <div className="col-md-1 col-sm-1 ">
            <div>
              <button
                onClick={() => handleRemoveInput(index)}
                className="btn btnIc"
              >
                <Delete />
              </button>
            </div>
          </div>
        )}
        {keyValuePairs.length === index + 1 && (
          <div className="col-md-12 col-sm-1 ">
            <div>
              <button onClick={handleAddInput} className="btn btnIc">
                <Add />
              </button>
            </div>
          </div>
        )}
      </div>
    ));
  };

  const imageApi = async (index) => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/image-view`,
        {
          prompt: index,
        }
      );

      return response.data.data;
    } catch (error) {
      console.error("Error in imageApi:", error);
      throw new Error("Unable to fetch image data");
    }
  };

  const jsonApi = async (index) => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/prompt-to-json`,
        {
          prompt: index,
        }
      );
      console.log(response.data);
      return response.data;
    } catch (error) {
      console.error("Error in imageApi:", error);
      throw new Error("Unable to fetch image data");
    }
  };

  const getCredits = async () => {
    const result = await axios.get(
      `https://www.apis.foundationmixer.com/nfts/getCredits/?walletAddress=${address}`
    );
    if (result.status === 200) {
      setCredits(result.data.credits);
    }
  };

  const editPromptHandler = (index) => {
    setActiveIndex(index);
    setEditPrompt(aiJson[index].prompt);
  };

  const updateData = async () => {
    setUpLoader(true);
    try {
      const response = await imageApi(editPrompt);
      const json = await jsonApi(editPrompt);
      console.log("editprompt", editPrompt);
      console.log("res", response);

      const updatedData = aiJson.map((item) => {
        if (item.id === activeIndex + 1) {
          return {
            ...item,
            prompt: editPrompt,
            image: response[0].url,
            json: json,
          };
        }
        return item;
      });

      setAiJson(updatedData);
      setUpLoader(false);
    } catch (error) {
      alert("Error updating data:");
      setUpLoader(false);
    }
  };

  useEffect(() => {
    getCredits();
  }, []);

  const savePromptHandler = async () => {
    setULoader(true);
    console.log("287", aiJson);
    const imageLinks = aiJson.map((item) => {
      const { id, json, ...other } = item;
      return other;
    });

    const jsonList = aiJson.map((item) => {
      const { id, json, ...other } = item;
      return json;
    });

    console.log(imageLinks);

    // const jsonObjects = [...keyValuePairs, { key: "object", value: obj }];
    // const objArry = jsonObjects.map((item) => {
    //   const newItem = {};
    //   newItem[item.key] = item.value;
    //   return newItem;
    // });
    // console.log(objArry);

    const data = {
      walletAddress: address,
      imageLinks: imageLinks,
      jsonObjects: jsonList,
    };
    console.log(data);

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/users`,
        data
      );
      setULoader(false);
      alert("Api Sucess");
    } catch (error) {
      alert(error.response.error);
      setULoader(false);
    }
  };

  return (
    <>
      <div className="col-md-6 col-sm-12 bannerLeft">
        <h3>Enter Object</h3>
        <div className="form-control mb-50">
          <input
            value={obj}
            onChange={(e) => setObj(e.target.value)}
            type="text"
            placeholder="Cat,Dog etc..."
          />
        </div>
      </div>

      <div
        className="col-md-6 col-sm-12 bannerLeft"
        style={{ paddingBottom: "20px" }}
      >
        <h3>Enter Total No nft</h3>
        <div className="col-md-5 col-sm-12 bannerLeft">
          <div className="form-control ">
            <input
              type="number"
              placeholder="No of NFT"
              value={no}
              onChange={(e) => setNo(e.target.value)}
            />
          </div>
        </div>
      </div>

      <div className="col-md-6 col-sm-12 bannerLeft">
        <h3>Enter Keys and Values</h3>
        {renderInputs()}
      </div>
      <br />
      <div className="col-md-6 col-sm-12 bannerLeft">
        <h3>Enter example</h3>
        <div className="form-control mb-50">
          <input
            value={sentance}
            onChange={(e) => setSentance(e.target.value)}
            type="text"
            placeholder="cat with red background"
          />
        </div>
      </div>

      <div className="noOfImages" style={{ width: "320px" }}>
        <input
          type="radio"
          className="input-hidden"
          id="html3"
          name="fav_language"
          value="HTML3"
          checked={true}
          disabled
        />
        <label for="html3">
          Your Current Credits
          <img src={Doller} />
          {credits} credits
        </label>
      </div>
      <br />
      <div className="gnBtn">
        <div className="noOfImages" onClick={() => setCounter(1)}>
          <input
            type="radio"
            className="input-hidden"
            id="html3"
            name="fav_language"
            value="HTML3"
            checked={counter == 1 ? true : false}
          />
          <label for="html3">
            1 Image
            <img src={Doller} />
            0.25 credit
          </label>
        </div>

        <div className="noOfImages" onClick={() => setCounter(4)}>
          <input
            type="radio"
            className="input-hidden"
            id="html1"
            name="fav_language"
            value="HTML1"
            checked={counter == 4 ? true : false}
          />
          <label for="html1">
            4 Image
            <img src={Doller} />1 credit
          </label>
        </div>
        <div className="noOfImages" onClick={() => setCounter(40)}>
          <input
            type="radio"
            className="input-hidden"
            id="html2"
            name="fav_language"
            value="HTML2"
            checked={counter == 40 ? true : false}
          />
          <label for="html2">
            40 Images
            <img src={Doller} />
            10 credit
          </label>
        </div>
      </div>

      <div className="styleSection mb-50">
        <button className="btn" onClick={() => handleJsonGenerator()}>
          {loader ? (
            <div className="spinner-border" role="status">
              <span className="sr-only">Loading...</span>
            </div>
          ) : (
            "Generate Images"
          )}
        </button>
      </div>

      {activeIndex !== undefined && (
        <div className="col-md-6 col-sm-12 bannerLeft my-5">
          <h3>Edit Prompt</h3>
          <div className="form-control mb-50">
            <input
              value={editPrompt}
              onChange={(e) => setEditPrompt(e.target.value)}
              type="text"
              placeholder=""
            />
          </div>
          <button
            className="btn"
            style={{ marginTop: "10px", marginBottom: "20px", padding: 0 }}
            onClick={updateData}
          >
            {upLoader ? (
              <div className="spinner-border" role="status">
                <span className="sr-only">Loading...</span>
              </div>
            ) : (
              "Update"
            )}
          </button>
        </div>
      )}
      <div style={{ display: "flex", gap: "10px" }}>
        {aiJson?.map((data, index) => (
          <div style={{ display: "flex", gap: "20px", width: "100%" }}>
            <div
              style={{
                position: "relative",
                height: "100%",
                width: "100%",
              }}
            >
              <div
                style={{
                  position: "absolute",
                  top: "0px",
                  right: "0px",
                  color: "#000",
                  zIndex: "9999",
                  padding: "0px",
                }}
              >
                <button
                  onClick={() => editPromptHandler(index)}
                  className="btn btnIc"
                  style={{ opacity: 0.8 }}
                >
                  <Edit />
                </button>
              </div>
              <div>
                <img
                  style={{ width: "100%", height: "100%" }}
                  src={data.image}
                />
                <div>
                  <p>{data.prompt}</p>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
      {aiJson.length > 0 && (
        <button className="btn" onClick={savePromptHandler}>
          {uLoader ? (
            <div className="spinner-border" role="status">
              <span className="sr-only">Loading...</span>
            </div>
          ) : (
            "Save Prompt"
          )}
        </button>
      )}
    </>
  );
}

export default KeyValueForm;
